class utilitiesInscription {
	constructor(config) {
		this.config = {
			...defaults,
			...config
		};
	}

	initialize() {
		this._eventChangeCivilite();
	}

	/// 
	/// Return un boolean indiquant si les champs requis de idForm sont non vides
	checkForm(idForm, dataRequired) {
		let self = this;
		let obj = self._getDataForm(idForm);
		let arr = [];
		const regexMail = /^[a-zA-Z0-9._-]+@[a-z0-9._-]{2,}\.[a-z]{2,4}$/;
		for (var i = 0; i < dataRequired.length; i++) {
			if (idForm !== 'RegisterForm' && idForm !== 'PasswordActivation' && idForm !== 'voyageursForm' && idForm !== 'optionsForm') {
				if (dataRequired.includes('Email') || dataRequired.includes('email')) {
					// pour l'email, on teste la valeur entrée
					if (!regexMail.test(document.getElementById('Email').value)) {
						return false;
					} else {
						return true;
					}
				}
			} else if (obj[dataRequired[i]] === '' || obj[dataRequired[i]] === undefined) {
				arr.push(false);
			} else {
				arr.push(true);
			}
		}
		const isFormIsComplete = arr.every(bool => bool);

		return isFormIsComplete;
	}
	/// @return an object
	_getDataForm(idForm) {
		let formElement = document.getElementById(idForm);
		let obj = {}
		try {
			let str = new URLSearchParams(new FormData(formElement)).toString();
			obj = str
				.split('&')
				.map(x => x.split('=')
					.map(y => y.trim())
					.map(z => z.replaceAll('.', '_')))
				.reduce((a, x) => {
					a[x[0]] = x[1];
					return a;
				}, {});
		} catch (e) {
			console.error(`
				Le paramètre idForm de la	function _getDataForm semble poser problème.\nidForm vaut "${idForm}".\nLes causes les plus probables: \n\ t1 / idForm n 'est pas un id mais un element html\n\t2/ l'élément document.getElementById(idForm) n'existe pas sur la page.`);
		}
		return obj;
	}


	/// Function pour mettre un masque sur les champs date de naissance
	_maskInput(element) {
		Maska.create(element);
	}

	/// @event
	/// initialisation de la function _toggleFieldNomUsage
	/// page option
	_eventChangeCivilite() {
		let self = this;
		let selectCivilite = document.querySelectorAll('[data-select="civilite-A"]');

		selectCivilite.forEach(function (el) {
			self._toggleFieldNomUsage(el);
			el.addEventListener('change', function () {
				self._toggleFieldNomUsage(el);
			});
		})
	}

	/// affichage du message `Nom d'usage` ou non 
	/// selon la value de la civilité
	_toggleFieldNomUsage(civilite) {
		let index = 0;
		let selectorParent = '.formulaire';
		//let arr = ['coordonnees', 'creation', 'relance'];
		let arr = ['coordonnees', 'relance'];
		if (arr.includes(config.page)) {
			selectorParent = '.coordonnees__pax';
		}

		try {
			if (parseInt(civilite.value) === 2) {
				civilite.closest(selectorParent).querySelector('.field--usage').style.display = "block";
				civilite.closest(selectorParent).querySelector('.field--nom label').innerText = "Nom de naissance";
				civilite.closest(selectorParent).querySelector('[data-msg-civilite]').setAttribute('data-msg-civilite', true);
			} else {
				civilite.closest(selectorParent).querySelector('.field--usage').style.display = "none";
				civilite.closest(selectorParent).querySelector('.field--nom label').innerText = "Nom";
				civilite.closest(selectorParent).querySelector('[data-msg-civilite]').setAttribute('data-msg-civilite', false);
			}
		} catch (e) {
			console.error(e, civilite, index);
		}
	}

	/// @requete ajax
	/// Gestion des libertés : switch devis/inscription
	/// cas on ne change pas de nombre de pax
	_poursuiteInscriptionIndiv(nbPax) {
		return new Promise(resolve => {
			let goToContinue = true;
			let data = {
				codeProduit: config.codeProduit,
				dateDepart: config.dateDepart,
				nbPax: nbPax
			}

			fetch(this.config.url.continueToInscriptionIndiv, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify(data)
				}).then(res => {
					return res.text();
				}).then(response => {
					if (response !== '') {
						goToContinue = JSON.parse(response);
					}
				}).then(res => {
					resolve(goToContinue)
				})
				.catch(function (error) {
					console.error(error);
				});
		});
	}

	/// UTILITIES
	/// Page /inscription/coordonnees/{codeCircuit}/JJ-MM-AAAA
	/// modale nouveau passager (codeType du circuit === 2)
	_templating(idTemplate, ibBlock, callback) {
		if ("content" in document.createElement('template')) {
			// on récupère l'id du <template> 
			// et celui du block dans lequel on va insérer le contenu
			let template = document.getElementById(idTemplate);
			let blockContainer = document.getElementById(ibBlock);

			// On clone le contenu et on l'insère dans le block
			var clone = document.importNode(template.content, true);
			blockContainer.appendChild(clone);

		}
	}
}